var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow"},[_c('h2',{staticClass:"text-black md:text-4xl leading-9 md:mt-4 -mt-2 text-bold text-center"},[_vm._v(_vm._s(_vm.time))])])}
var staticRenderFns = []

export { render, staticRenderFns }